import React from 'react';
import {useProductAttributes} from "../../../state";
import {FormattedMessage} from "react-intl";

export const SafetyStihl = () => {
    const {customAttributes, categories} = useProductAttributes() || {};
    const manufacturer = customAttributes?.find(
        attribute => attribute.attribute_code === 'manufacturer'
    )?.value;
    const hasCategory26 = categories?.some(category => category.id === 26);

    if (manufacturer === 'Stihl' && hasCategory26) {
        return (
            <div
                className={'react-css rounded-xl bg-cards-bg flex flex-col xl:p-4 p-6 mt-4 xl:mt-6 items-center gap-3 '}
            >
                <div className={'flex flex-row gap-2'}>
                    <svg className={'fill-current text-gray-500 w-6 h-6'}
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3
                        0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7
                        24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
                    </svg>
                    <span className={'text-start text-custom-gray font-nunito text-base font-bold leading-6 uppercase'}>
                        <FormattedMessage id={"safety_measures"} />
                    </span>
                </div>
                <div className="content">
                    <p className={'text-start text-custom-gray font-nunito text-sm'}>
                        <FormattedMessage id={"safety_info"} /><br />
                        <FormattedMessage id={"safety_clothing"} /><br />
                        <FormattedMessage id={"safety_clarification"} /><br />
                        <br />
                        <FormattedMessage id={"safety_more_info"} />
                        <a className={'ml-1 underline'}
                           rel="nofollow"
                           href="https://www.youtube.com/user/STIHLRomania"
                           target="_blank"
                           title="YouTube Stihl Romania"
                        >
                            <FormattedMessage id={"youtube_channel"} />
                        </a>
                    </p>
                </div>
            </div>
        );
    } else {
        return null;
    }
};
